export default __webpack_public_path__ + "static/media/bt.c22e6407.svg";